<template>
  <div class="dod-chart-holder" >    
    <BarChart v-if="is_bar"  :chart-data="chartData" :chart-options="chartOptions" />    
    <LineChart v-if="is_line" :chart-data="chartData" :chart-options="chartOptions"  />
    <DoughnutChart v-if="is_doughnut" :chart-data="chartData" :chart-options="chartOptions" />
    <PieChart v-if="is_pie" :chart-data="chartData" :chart-options="chartOptions" />
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue';
import { BarChart, LineChart, DoughnutChart, PieChart } from 'vue-chart-3';
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);


// Define the chart component
// const BarChart = defineChartComponent('bar');
// const LineChart = defineChartComponent('line');
/* 
        this object should be passed from the parent component
        the format should be 
        data: {
        [key]: {
            values: [value, value, value],
            labels: [label, label, label],
            backgroundColor: [color, color, color],
            borderColor: [color, color, color]
        },
        [key2]: {
            values: [value, value, value],
            labels: [label, label, label],
            backgroundColor: [color, color, color],
            borderColor: [color, color, color]
        }
  }
    */
const props = defineProps({
  chart: {    
    type: Object,
    required: true
  },
  type: {
    type: String,
    required: true
  }
});

const chartOptions = {
  responsive: true,
  plugins: { legend: { position: 'top' } }
};

const is_bar = computed (() => {
  return props.type === 'bar';
});

const is_line = computed (() => {
  return props.type === 'line';
});

const is_doughnut = computed (() => {
  return props.type === 'doughnut';
});

const is_pie = computed (() => {
  return props.type === 'pie';
});

// const chartData = {
//   labels: ['Jan', 'Feb', 'Mar', 'Apr'],
//   datasets: [
//     {
//       label: 'Sales',
//       data: [30, 50, 40, 70],
//       backgroundColor: ['red', 'blue', 'green', 'purple']
//     }
//   ]
// };


const chartData = computed(() => {
    var data = Object.entries(props.chart.data).map(([key, value]) => ({
        label: key, // Use the key as the dataset label
        data: value.values,
        labels: value.labels, // Keep labels for reference (can be used separately)
        backgroundColor: value.backgroundColor,
        borderColor: value.borderColor,
        borderWidth: 1
    }));
    return {
        labels: props.chart.labels,
        datasets: data
    };
});


</script>